import React, { useEffect } from "react";
import { Layout, message } from "antd";
import { useSetRecoilState } from "recoil";
import {
  tenantsInfo as recoilTenantsInfo,
  appReady as recoilAppReady,
} from "../../recoil";
import { permissionCodeObj as recoilPermissionCodeObj } from "../../recoil/account";
import { i18n as i } from "@/i18n";
import "../mainLayout.less";
import { setAccessToken, setRefreshToken } from "../../utils/sessionToken";
import { goLogout } from "../../utils/sso";
import { isQiankun as recoilQiankun } from "../../recoil/qiankun";
import { Outlet } from "react-router-dom";
import { getRootProps } from "@/share/shared";

function QiankunMainLayout() {
  const setTenantsInfo = useSetRecoilState(recoilTenantsInfo);
  const setPermissionCodeObj = useSetRecoilState<any>(recoilPermissionCodeObj); // 菜单权限校验
  const setAppReady = useSetRecoilState(recoilAppReady);
  const setIsQiankun = useSetRecoilState(recoilQiankun);

  // 初始化
  useEffect(() => {
    setIsQiankun(window.__POWERED_BY_QIANKUN__);
    const rootProps = getRootProps();
    if (rootProps) {
      console.log("rootProps", rootProps);
      const {
        tenants = {},
        userPermission = {},
        accessToken = "",
        refreshToken = "",
      } = rootProps;
      setTenantsInfo(tenants);
      setPermissionCodeObj(userPermission);
      if (accessToken) {
        setAccessToken(accessToken);
        setAppReady(true);
      } else {
        message.error(i("无token信息，请重新登陆"));
        setTimeout(() => {
          goLogout();
        }, 1000);
      }
      if (refreshToken) {
        setRefreshToken(refreshToken);
      }
    } else {
      message.error(i("无token信息，请重新登陆"));
      setTimeout(() => {
        goLogout();
      }, 1000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout className="main">
      <div className={"qiankun-site-layout-background"}>
        <Outlet />
      </div>
    </Layout>
  );
}

export default QiankunMainLayout;
